import React from "react";

import { Interpretation } from "lib/build/schema";

import { useFormatFsn } from "src/common/hooks/useFormatFsn";

export function useConceptOptions(interpretations: Interpretation[]): {
	label: string;
	value: string;
}[] {
	const formatFsn = useFormatFsn();
	return React.useMemo(
		() =>
			interpretations.map(({ vocab, code }) => ({
				value: `${vocab}|${code}`,
				label: formatFsn({ vocab, code })
			})),
		[interpretations, formatFsn]
	);
}
